import React from 'react';
import SidebarUnitDesktop from 'components/sidebar/components/SidebarUnitDesktop';
import { DocumentIcon } from 'assets/icons';
import UseContext from 'hooks/useContext';

const PayslipManagementDL = ({ pathname }) => {
  const { sidebarExpanded } = UseContext();
  return (
    <SidebarUnitDesktop
      routeName={'Paie & Factures'}
      routeSidebar={'/payslipManagement/payslips'}
    >
      <span className="shrink-0">
        <DocumentIcon
          wh={24}
          color={`${pathname.includes('payslipManagement') ? '#FF9600' : '#374151'}`}
        />
      </span>
      <span
        className={`ft-sm font-medium ml-3 ls:opacity-0 ls:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200 ${
          !sidebarExpanded ? 'tab:max-2xl:hidden' : ''
        } ${pathname.includes('payslipManagement') && '!text-[#FF9600]'}`}
      >
        Paie & Factures
      </span>
    </SidebarUnitDesktop>
  );
};

export default PayslipManagementDL;
